import { render, staticRenderFns } from "./BigCommerce.vue?vue&type=template&id=0ed65db9"
import script from "./BigCommerce.vue?vue&type=script&lang=js"
export * from "./BigCommerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports